/**
 * Twin3D themes — ported from Claude Design handoff bundle
 * (`mall-analytics-dashboard/project/data.js` THEMES).
 *
 * Each theme carries:
 *   scene: Three.js material/color/exposure/bloom values
 *   css:   :root CSS variable overrides for surrounding UI chrome
 */

export const THEMES = {
    cyber: {
        label: 'Cyber-Ops',
        scene: {
            bg: '#05080f',
            fog: '#05080f',
            floor: '#0a1020',
            floorEmissive: '#0b1530',
            gridMajor: '#39e6ff',
            gridMinor: '#1b6f8c',
            glassTint: '#5cc7f5',
            edge: '#7df4ff',
            accent: '#38e6ff',
            accentB: '#b15cff',
            keyLight: '#cfe9ff',
            rim: '#7b5cff',
            bloom: 0.72,
            exposure: 1.12,
        },
        css: {
            '--v3-twin-accent': '#38e6ff',
            '--v3-twin-bg': '#070b14',
            '--v3-twin-surface': '#0c1322',
            '--v3-twin-border': '#243454',
            '--v3-twin-text': '#eaf4ff',
            '--v3-twin-text-muted': '#a7c0e0',
        },
    },
    teal: {
        label: 'EGoal Teal',
        scene: {
            bg: '#04141a',
            fog: '#04141a',
            floor: '#072028',
            floorEmissive: '#06303a',
            gridMajor: '#1fd0e6',
            gridMinor: '#11707e',
            glassTint: '#3fcdd8',
            edge: '#4ef0f6',
            accent: '#19c6db',
            accentB: '#3ad6a8',
            keyLight: '#d6f6fb',
            rim: '#1f9f8f',
            bloom: 0.66,
            exposure: 1.1,
        },
        css: {
            '--v3-twin-accent': '#19c6db',
            '--v3-twin-bg': '#06181d',
            '--v3-twin-surface': '#0a2229',
            '--v3-twin-border': '#1d4b55',
            '--v3-twin-text': '#eafafd',
            '--v3-twin-text-muted': '#a4ccd4',
        },
    },
    ember: {
        label: 'Ember Warm',
        scene: {
            bg: '#100e0b',
            fog: '#100e0b',
            floor: '#15130f',
            floorEmissive: '#1c160f',
            gridMajor: '#ff8359',
            gridMinor: '#5a3a26',
            glassTint: '#ffb182',
            edge: '#ffae7a',
            accent: '#ff6a3d',
            accentB: '#f4a932',
            keyLight: '#ffe9d4',
            rim: '#c2410c',
            bloom: 0.52,
            exposure: 1.04,
        },
        css: {
            '--v3-twin-accent': '#ff6a3d',
            '--v3-twin-bg': '#120e0a',
            '--v3-twin-surface': '#1a140d',
            '--v3-twin-border': '#3a2616',
            '--v3-twin-text': '#fff3e8',
            '--v3-twin-text-muted': '#d8b598',
        },
    },
};

export const HEAT_RAMP = ['#1f4fd8', '#1fb6d8', '#37d07a', '#f4c233', '#f4742f', '#e23b3b'];

export const HEALTH = {
    occupied: { label: 'Occupied', color: '#2563eb' },
    vacant: { label: 'Vacant', color: '#94a3b8' },
    'under-fitout': { label: 'Under fit-out', color: '#f59e0b' },
};

export const DEFAULT_THEME = 'cyber';
